import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServiceRespone } from 'src/app/model/serviceResponse';
import { StatoProcedura } from 'src/app/model/statoProcedura';
import { Matricola } from 'src/app/pages/svincoli/model/matricola';

import { AppConstants } from 'src/environments/constants';
import { CommonUtils } from 'src/utils/CommonUtils';
import { msConfig } from '../ms-config';
import { ISvincoliService } from './ISvincoliService';

@Injectable({
  providedIn: 'root'
})
export class SvincoliService implements ISvincoliService {

  constructor(private http: HttpClient) { }


  getSvincoli(isTeamView: boolean, first: number, length: number, fornitore?: string, codiceOrdine?: string, stato?: StatoProcedura, dataInizio?: Date, dataFine?: Date, filtroIspettore?:Number, ordinamento?: string, direzione?: boolean, posizioniCollaudo?: boolean): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_SVINCOLI;
    console.log(url)
    let params: any = {};
    params.isTeamView = isTeamView
    params.first = first
    params.length = length
    params = CommonUtils.containsParam(params, fornitore, "fornitore")
    params = CommonUtils.containsParam(params, filtroIspettore, "idIspettore")
    params = CommonUtils.containsParam(params, codiceOrdine?.trim(), "codiceOrdine")
    params = CommonUtils.containsParam(params, stato, "stato")
    params = CommonUtils.containsParam(params, ordinamento, "ordinamento")
    params = CommonUtils.containsParam(params, direzione, "direzione")
    params = CommonUtils.containsParam(params, posizioniCollaudo, "collaudo")
    if (dataInizio != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataInizio), "dataInizio")
    }
    if (dataFine != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataFine), "dataFine")
    }

    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let svincoli;
        svincoli = resp;
        return svincoli;
      }))
  }

  getTotaleSvincoli(isTeamView: boolean, fornitore?: string, codiceOrdine?: string, stato?: StatoProcedura, dataInizio?: Date, dataFine?: Date,filtroIspettore?:Number,posizioniCollaudo?: boolean): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_TOTALE_SVINCOLI
    let params: any = {};
    params.isTeamView = isTeamView
    params = CommonUtils.containsParam(params, fornitore, "fornitore")
    params = CommonUtils.containsParam(params, filtroIspettore, "idIspettore")
    params = CommonUtils.containsParam(params, codiceOrdine?.trim(), "codiceOrdine")
    params = CommonUtils.containsParam(params, stato, "stato")
    params = CommonUtils.containsParam(params, posizioniCollaudo, "collaudo")
    if (dataInizio != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataInizio), "dataInizio")
    }
    if (dataFine != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataFine), "dataFine")
    }
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp
      }), catchError(CommonUtils.errorHandler))

  }

  getDettaglioSvincolo(isTeamView: boolean, idSvincolo: number): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_SVINCOLI + '/' + idSvincolo
    console.log(url)
    let params: any = {};
    params.isTeamView = isTeamView

    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let dettaglioSvincolo;
        dettaglioSvincolo = resp;
        return dettaglioSvincolo;
      }))
  }

  getMatricoleSvincolo(isTeamView: boolean, idSvincolo: number, first: number, length: number): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_SVINCOLI + '/' + idSvincolo + AppConstants.PATH_GET_MATRICOLE;
    let params: any = {};
    params.isTeamView = isTeamView
    params.first = first;
    params.length = length;
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let matricole;
        matricole = resp;
        return matricole;
      }))
  }

  getTotaleMatricole(idSvincolo: number): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_SVINCOLI + '/' + idSvincolo + AppConstants.PATH_TOTALE_MATRICOLE;
    let params: any = {};
    //params.isTeamView = isTeamView;

    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let tot;
        tot = resp;
        return tot;
      }),
      catchError(CommonUtils.errorHandler))

  }

  cambioStato(idSvincolo: number, stato: StatoProcedura, quantita: number, matricole: Matricola[], idPartita: number, forzaCancellazione: boolean): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_SVINCOLI + '/' + idSvincolo + AppConstants.PATH_CAMBIA_STATO
    let params: any = {};
    params.nuovoStato = stato
    params.matricole = matricole
    params.quantita = quantita
    params.idPartita = idPartita
    params.forzaCancellazione = forzaCancellazione

    return this.http
      .put(url, params)
      .pipe(map((resp: ServiceRespone) => {
        let ordini;
        ordini = resp;
        return ordini;
      }));
  }

  isSvincoloApertoSuPosizione(idPosizione: number): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_IS_SVINCOLI_APERTI;
    let params: any = {};
    params.idPosizione = idPosizione
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  uploadExcelMatricole(idMateriale: number, idSvincolo: number, idPosizione: number, excel: File): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_UPLOAD_EXCEL;

    let formData = new FormData();
    formData.append('excel', excel);

    let params: any = {};
    params.idMateriale = idMateriale
    params.idSvincolo = idSvincolo
    params.idPosizione = idPosizione

    console.log(params);
    return this.http
      .post(url, formData, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }


}
